import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { typography } from '../../../../styles/typography';
import { MediaQueries } from '../../../../styles/Grid';

export const label = css(typography.effra22, {
  display: 'block',
  borderRadius: 2,
  border: `1px solid ${colorsPalette.grey20}`,
  padding: 16,
  [MediaQueries.lgAndUp]: {
    padding: 24,
  },
});
